import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedMenu = (props: ISvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <g id="menu_24px">
                <path
                    id="icon/navigation/menu_24px"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8V6H21V8H3ZM3 13H21V11H3V13ZM3 18H21V16H3V18Z"
                    fill={props.color}
                />
            </g>
        </svg>
    )
}
